/* eslint-disable import/no-unresolved */
import React, { Component } from "react";
import { connect } from "react-redux";
import { shape, bool } from "prop-types";

import { selectors as transactionsSelectors } from "reducers/transactions";
import { withMultipleSignaturesContext } from "pages/transactions/MultipleSignaturesTables/MultipleSignaturesDataContext";
import * as i18n from "util/i18n";

import I18n from "pages/_components/I18n";
import FormattedAmount from "pages/_components/FormattedAmount";
import CardContainer from "pages/_components/Card/CardContainer";
import Card from "pages/_components/Card/Card";

const getQuantityAndCurrency = (object) => {
    const amounts = object.transactionAmounts || {};
    const keys = Object.keys(amounts);
    if (keys.length > 0) {
        const currency = keys[0];
        return { currency, quantity: Number(amounts[currency]) || 0 };
    }
    const d = object.transaction?.data || {};
    if (d.amount != null && typeof d.amount !== "object") {
        return {
            currency: String(d.currency != null ? d.currency : "0"),
            quantity: Number(d.amount) || 0,
        };
    }
    if (d.amount && typeof d.amount === "object" && d.amount.quantity != null) {
        return {
            currency: String(d.amount.currency != null ? d.amount.currency : "0"),
            quantity: Number(d.amount.quantity) || 0,
        };
    }
    return { currency: "0", quantity: 0 };
};

class ChargebackRecurrencyDataTable extends Component {
    static propTypes = {
        multipleSignaturesData: shape({}).isRequired,
        isDesktop: bool.isRequired,
    };

    dataRow = () => {
        const { multipleSignaturesData, isDesktop } = this.props;
        const { selectedTransactionRows } = multipleSignaturesData;

        return selectedTransactionRows.map((object) => {
            const { transaction } = object;
            const { idTransaction, data = {}, submitDateTimeAsString } = transaction;
            const { sellerCuit, idDebin } = data;
            const sellerCuitValue = sellerCuit || (data.sellerDetail && data.sellerDetail.documentNumber) || "";
            const sellerCuitDisplay =
                sellerCuitValue && String(sellerCuitValue).trim() !== ""
                    ? String(sellerCuitValue).trim()
                    : i18n.get("multipleSignatures.chargebackRecurrency.emptyValue");
            const idDebinDisplay =
                idDebin && String(idDebin).trim() !== ""
                    ? idDebin
                    : i18n.get("multipleSignatures.chargebackRecurrency.emptyValue");
            const { currency, quantity } = getQuantityAndCurrency(object);

            const content = (
                <div className="chargeback-recurrency-card__motivo-row">
                    <div className="chargeback-recurrency-card__first-line">
                        <span className="chargeback-recurrency-card__label">
                            <I18n id="multipleSignatures.chargebackRecurrency.cuitVendorLabel" />
                        </span>
                        <span className="chargeback-recurrency-card__value">{sellerCuitDisplay}</span>
                    </div>
                    <div className="chargeback-recurrency-card__second-line">
                        <span className="chargeback-recurrency-card__label">
                            <I18n id="multipleSignatures.chargebackRecurrency.idRecurrenceLabel" />
                        </span>
                        <span className="chargeback-recurrency-card__value">{idDebinDisplay}</span>
                    </div>
                </div>
            );

            return (
                <CardContainer key={idTransaction} className="confirmation__cards-container mt-0">
                    <Card
                        isDesktop={isDesktop}
                        className="confirmation__cards chargeback-recurrency-card"
                        icon={isDesktop && "images/transfer-PENDING.svg"}
                        iconClass="card__pending-transaction-icon"
                        hrClass="d-none"
                        title={
                            !isDesktop && (
                                <div>
                                    {submitDateTimeAsString && (
                                        <div className="confirmation-cards__title">
                                            <div className="confirmation-cards__title-data">
                                                <I18n id="forms.transaction.ticket.date" />
                                            </div>
                                            <div className="confirmation-cards__title-info">
                                                <span>{submitDateTimeAsString}</span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )
                        }
                        content={isDesktop ? content : <div>{content}</div>}
                        rightContent={
                            <div className="confirmation-cards__right">
                                <div className="confirmation-cards__right-data">
                                    <FormattedAmount currency={currency} quantity={quantity} />
                                </div>
                            </div>
                        }
                    />
                </CardContainer>
            );
        });
    };

    render() {
        return this.dataRow();
    }
}

const mapStateToProps = (state) => ({
    multipleSignaturesData: transactionsSelectors.getMultipleSignaturesData(state),
});

export default connect(mapStateToProps)(withMultipleSignaturesContext(ChargebackRecurrencyDataTable));
